import { render, staticRenderFns } from "./calendar_item_menu.vue?vue&type=template&id=4b4cdea1&scoped=true"
import script from "./calendar_item_menu.vue?vue&type=script&lang=js"
export * from "./calendar_item_menu.vue?vue&type=script&lang=js"
import style0 from "./calendar_item_menu.vue?vue&type=style&index=0&id=4b4cdea1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b4cdea1",
  null
  
)

export default component.exports